import React, { useState, useEffect, useCallback } from "react";
import { Progress } from "antd";
import playerImg from "assets/playervideo.png";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import { api } from "services/api";
import Loading from "../../components/Loading";
// import { courses } from "utils/mocks";
import { useSelector } from "react-redux";

export const MyCoursesPage: React.FC = () => {
	const [userCourses, setUserCourses] = useState<any[]>([]);
	const [loading, setLoading] = useState<boolean>(false);
	const { id: userId } = useSelector((state: any) => state.app.user);
	const navigate = useNavigate();

	const handleLoadCourses = async () => {
		if (userId) {
			setLoading(true);
			await api
				.get(`/courses/users/${userId}`)
				.then((res) => {
					setLoading(false);

					const dataWithKeys = res.data.data.courses.map(
						(course: any, index: any) => {
							return {
								...course,
								key: index,
							};
						}
					);
					setUserCourses(dataWithKeys);
				})
				.catch((err) => {
					setLoading(false);
					console.log(err);
				});
		}
	};

	const handleCoursesCallback = useCallback(handleLoadCourses, [userId]);

	useEffect(() => {
		handleCoursesCallback();
	}, [handleCoursesCallback]);

	return (
		<div className="mycourses">
			<div className="mycourses__container">
				<h1 className="mycourses__container__title">MEUS CURSOS</h1>
				<div className="mycourses__container__items">
					{loading && <Loading title="Cursos" />}
					{userCourses.length !== 0 &&
						userCourses.map((course, index) => {
							const {
								age,
								author,
								description,
								id,
								percentage,
								title,
								tags,
								image,
							} = course;
							return (
								<div
									key={index}
									className="mycourses__container__items__card"
									onClick={() => {
										let modules;
										api
											.get(`/courses/${id}/modules/users/${userId}`)
											.then((res) => {
												modules = res.data.data.modules; // precisa formatar json na documentação da api
											});

										navigate(`/my-courses/${id}`, {
											state: {
												age,
												author,
												description,
												id,
												percentage,
												title,
												tags: tags ? tags.split(",") : null,
												modules,
												image,
											},
										});
									}}
								>
									<img
										src={course.image ? course.image : playerImg}
										alt=""
										width="250px"
									/>
									<div className="mycourses__container__items__card__info">
										<h1 className="mycourses__container__items__card__info__title">
											{course.title}
										</h1>
										<span className="mycourses__container__items__card__info__author">
											(Por {course.author})
										</span>
										<div>
											<Progress percent={course.percentage} showInfo={false} />
										</div>
										<p className="mycourses__container__items__card__info__description">
											{course.description}
										</p>
										<p className="mycourses__container__items__card__info__subtitle">
											Classificação indicativa: {course.age}
										</p>
									</div>
								</div>
							);
						})}
					{/* {courses.map((course) => {
						const {
							ageFilter,
							author,
							description,
							id,
							percent,
							title,
							tags,
							modules,
						} = course;
						return (
							<div
								className="mycourses__container__items__card"
								onClick={() => {
									navigate(`/my-courses/${id}`, {
										state: {
											ageFilter,
											author,
											description,
											id,
											percent,
											title,
											tags,
											modules,
										},
									});
								}}
							>
								<img src={playerImg} alt="" width="250px" />
								<div className="mycourses__container__items__card__info">
									<h1 className="mycourses__container__items__card__info__title">
										{course.title}
									</h1>
									<div>
										<Progress percent={course.percent} showInfo={false} />
									</div>
									<span className="mycourses__container__items__card__info__author">
										{course.author}
									</span>
									<p className="mycourses__container__items__card__info__description">
										{course.description}
									</p>
									<p className="mycourses__container__items__card__info__subtitle">
										Classificação indicativa: {course.ageFilter}
									</p>
								</div>
							</div>
						);
					})} */}
				</div>
			</div>
		</div>
	);
};
